import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { createResource, useResource } from '@/lib/i18n'
import { SiteLinksSearchBoxJsonLd, CorporateContactJsonLd, SocialProfileJsonLd } from 'next-seo'
import { captureException } from '@sentry/nextjs'
import BannerBox from '@/components/home/banner-box'
import { GetServerSideProps } from 'next'
import { isFromMobileFn, setCustomHeaders, setItem } from '@/lib/utils'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { initStore } from '@/store'
import axios from 'axios'
import { fetchPromoBannerPage } from '@/lib/api'

const Whys = dynamic(() => import('@/components/home/whys'))
const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))
const LearnMore = dynamic(() => import('@/components/home/learn-more'))
const Features = dynamic(() => import('@/components/home/features'))
const Funding = dynamic(() => import('@/components/home/funding'))
const SendMessage = dynamic(() => import('@/components/home/send-message'))
const GooglePlay = dynamic(() => import('@/components/common/google-play-btn'))
const Banks = dynamic(() => import('@/components/home/bank'))
const Area = dynamic(() => import('@/components/home/area'))
const Intrucation = dynamic(() => import('@/components/home/intrucation'))
const Promotion = dynamic(() => import('@/components/home/promotion'))
const Honours = dynamic(() => import('@/components/home/honours'))
const AssociatedMedia = dynamic(() => import('@/components/home/associated-media'))
// const Questions = dynamic(() => import('@/components/home/questions'))

const resource = createResource({
  en: {
    description:
      'KreditPintar | 5 mins to apply for cash loans online & instant application. Best online loans with high limit. Fast process and direct cash disbursement to your account. Smart Credit in Indonesia.',
  },
  id: {
    description:
      'Ajukan pinjaman online tunai di aplikasi instan KreditPintar. Limit pinjaman online hingga 50 Juta rupiah. Proses cepat dan pencairan langsung tunai ke rekeningmu.',
  },
})

const Home = (props: any) => {
  const { t } = useResource(resource)
  const { width, height } = useWindowSize()
  initStore().ConfigStore.setScreenWidth(width ? width : -1)
  initStore().ConfigStore.setScreenHeight(height ? height : -1)

  useEffect(() => {
    if (props.tkb) {
      delete props.tkb.createTime
      const tkb = props.tkb
      const list = Object.entries(tkb)
        .filter(([key]) => key.includes('tkb'))
        .map(([key, value]) => {
          return {
            key: key.toUpperCase(),
            value,
          }
        })
      setItem('tkbList', list)
    }

    if (props?.resultTkp) {
      setItem('resultTkp', props?.resultTkp)
    }
  }, [])

  return (
    <>
      <SiteLinksSearchBoxJsonLd
        url="https://www.kreditpintar.com/"
        potentialActions={[
          {
            target: 'https://www.kreditpintar.com/search?q',
            queryInput: 'search_term_string',
          },
        ]}
      />
      <CorporateContactJsonLd
        url="https://www.kreditpintar.com/"
        logo="https://www.kreditpintar.com/logo.png"
        contactPoint={[
          {
            telephone: '(021) 50598882',
            contactType: 'customer service',
            areaServed: 'ID',
            availableLanguage: ['English', 'Indonesian'],
          },
        ]}
      />
      <SocialProfileJsonLd
        type="Organization"
        name="Kredit Pintar"
        url="https://www.kreditpintar.com/"
        sameAs={[
          'https://www.facebook.com/KreditPintarOfficial',
          'https://twitter.com/kreditpintar',
          'https://www.instagram.com/kreditpintar',
        ]}
      />
      <KPHead metaTitle="home" description={t('description')} />
      <TopNavigation />
      <BannerBox isFromMobile={props.isMobile} />
      <Whys />
      <LearnMore />
      <Promotion promotionList={props.promotionList} />
      <Features />
      {props.resultTkp && Object.keys(props.resultTkp).length > 0 && <Funding resultTkp={props.resultTkp} />}
      <Banks />
      <Honours />
      <AssociatedMedia />
      {/* <Questions /> */}
      <Area />
      <Intrucation />
      <SendMessage />
      <Footer />
      <GooglePlay />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  setCustomHeaders(req, res, 'home')

  let promotionList = {}
  try {
    const promoBanner: any = await fetchPromoBannerPage()
    promotionList = promoBanner?.acf ?? {}
  } catch (error) {
    captureException(error)
  }

  try {
    const result: any = await axios.get('http://raven.id-lending:8080/kpi-tkb')
    const resultTkp: any = await axios.get('http://raven.id-lending:8080/kpi-tkp')
    return {
      props: {
        isMobile: isFromMobileFn(req.headers['user-agent']),
        tkb: result?.data,
        resultTkp: resultTkp?.data,
        promotionList,
      },
    }
  } catch (error) {
    captureException(error)
    return {
      props: {
        isMobile: isFromMobileFn(req.headers['user-agent']),
        tkb: {},
        resultTkp: {},
        promotionList,
      },
    }
  }
}

export default Home
